<form #heroForm="ngForm" (ngSubmit)="submit()" class="service-filters_form">

  <div class="filter" style="margin-left: 10px;">
    <iv-live-dropdown
      #expirationsDropdown
      [(selectedData)]="expirations"
      (selectedDataChange)="changeFilter('expirations', $event)"
      [cssClass]="'filter-expiration'"
      [data]="expirationList"
      [hasMultipleChoice]="true"
      [label]="'Expirations'"
      [type]="'expirations'"
      [valueAttribute]="'value'"
    >
    </iv-live-dropdown>
  </div>

  <div class="filter filter_center" style="margin-left: 10px;">
    <iv-live-number-input
      [(selectedData)]="center"
      (selectedDataChange)="changeFilter('center', $event)"
      [cssClass]="'filter-expiration'"
      [label]="'Mid price'"
    >
    </iv-live-number-input>
  </div>

  <div class="filter filter_strike" style="margin-left: 10px;">
    <iv-live-dropdown
      [(selectedData)]="strikesN"
      (selectedDataChange)="changeFilter('strikesN', $event)"
      [cssClass]="'filter-strike'"
      [data]="strikes"
      [label]="getClientWidth() > 1440? 'Strikes N': ''"
      [type]="'strike'"
    >
    </iv-live-dropdown>
  </div>

  <div class="filter filter_type" style="margin-left: 10px; ">

    <iv-live-dropdown
      [(selectedData)]="type"
      (selectedDataChange)="changeFilter('type', $event)"
      [cssClass]="'filter-call'"
      [data]="types"
      [label]="getClientWidth() > 1440? 'Type': null"
      [type]="'type'"
      [valueAttribute]="'name'"
    >
    </iv-live-dropdown>

  </div>

  <div class="buttons-container">
    <button (click)="onDownloadCSVClick($event)" class="iv-img-button  with-tip" id="downloadService"
            statistic
            statisticElementName="Click Option Monitor download csv"
            style="margin-left: 10px;" type="button">
      <div class='square-content'>
        <div>
          <span class="material-icons">&#xE884;</span>
        </div>
      </div>
      <span class="tip" style="right: 0; text-align: center; padding: 5px 20px;">
        Download data
      </span>
    </button>



  </div>

</form>


